module.exports = __webpack_public_path__ + "img/hint-ad.27f00692.png";